<template lang="pug">
div(class="h-full")
    div(class="sticky top-4 max-w-4xl m-auto")
        div
            div
                Carousel(
                    :scrollTo="currentSlide"
                    arrowMode="NONE"
                    :arrowMode="$device.isMobile ? 'ALWAYS' : 'NONE'"
                    arrowStyle="THIN"
                )
                    template(v-for="(image, index) in gallery")
                        div(
                            :key="`main-${image.filename}-${index}-${imageOptions.width}-${imageOptions.height}`"
                            class="w-full cursor-pointer"
                            @click="showLightbox(index)"
                        )
                            GalleryImage(
                                :src="$getImageUrl(image.key, image.filename, imageOptions.width, imageOptions.height, 80, 'fff')"
                                :width="imageOptions.width"
                                :height="imageOptions.height"
                                :alt="image.title"
                                :isLazy="index > 0"
                                class="mx-auto"
                            )

            div(
                v-if="showThumbs && gallery.length > 1"
                class="mt-4 mx-auto hover:cursor-pointer"
            )
                Carousel(containerClass="gap-x-1 mb-2")
                    div(
                        v-for="(image, index) in gallery"
                        :key="`thumb-${image.key}-${index}-${image.filename}`"
                        @click="activateThumb(index)"
                        class="border-2 border-solid w-[140px]"
                        :class="[ activeThumb === index ? 'border-primary' : 'border-transparent' ]"
                    )
                        GalleryImage(
                            :src="$getImageUrl(image.key, image.filename, 140, 105, 70)"
                            :width="140"
                            :height="105"
                            :isLazy="index <= ($device.isMobile ? 2 : 5)"
                        )

            div
                slot(name="footer")

    Lightbox(
        v-if="activeOverlay == 'gallery'"
        uniqueKey="gallery"
        :items="lightboxItems"
        :options="lightboxOptions"
        @close="hideLightbox"
    )

</template>

<script>
// TODO: In the future we should be able to create thumbs on the fly after Chris is done with his AWS stuffs, thus the 1 array of images for now
import Carousel from '@/components/carousel'
import GalleryImage from './galleryImage'
const Lightbox = () =>
    import(/* webpackChunkName: "photoswipe-lightbox" */ '@/components/overlay/photoswipeLightbox')

export default {
    name: 'GalleryCarousel',
    components: {
        Carousel,
        Lightbox,
        GalleryImage,
    },
    props: {
        gallery: {
            type: Array,
            required: true,
        },
        showThumbs: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            currentSlide: 0,
            activeThumb: 0,
            lightboxOptions: {
                index: 0,
                closeOnScroll: false,
                history: false,
                shareEl: false,
                fullscreenEl: false,
            },
        }
    },
    computed: {
        activeOverlay() {
            return this.$overlay.state.activeOverlay
        },
        imageOptions() {
            const width = this.$device.isMobile ? 390 : 860
            const height = this.$device.isMobile ? 293 : 650

            return { width, height }
        },
        lightboxItems() {
            return (
                this.gallery.map((image) => {
                    // create new image array with image objects in format that photoswipe likes
                    return {
                        src: this.$getImageUrl(image.key, image.filename, 1024, 768, 80, 'fff'),
                        w: 1024,
                        h: 768,
                        title: image.title,
                    }
                }) || []
            )
        },
        fitmentData() {
            return this.$store.state.fitment.data
        },
    },
    mounted() {
        this.$overlay.registerUrlKey('gallery')
    },
    methods: {
        createMainSlide() {},
        activateThumb(index) {
            this.currentSlide = index
            this.activeThumb = index
        },
        showLightbox(index) {
            this.$overlay.show('gallery')
            this.$set(this.lightboxOptions, 'index', index)
        },
        hideLightbox() {
            this.$overlay.hide()
        },
    },
}
</script>
